import React from 'react'; 
import HeaderNav from '../components/HeaderNav';
import DateComponent from '../components/DateComponent';
import PageIntro from '../components/PageIntro';
import HomePanels from '../components/HomePanels'; 
import WhySiso from '../components/WhySiso';

function Home() {


    return (
      <div id="mainContent">
        <div id="navHolder">
          <HeaderNav pageTitle="home" />
        </div>

        <div id = "navSpace" className= "tenHigh">
		    </div>
		    <div id = "intro">
			    <h1>WELCOME TO</h1>
			    <h1 id = "welcome">SISO</h1>
			    <div id = "introLogo">
				    <svg version= "1.1" id = "sisoLogo" role="img" aria-labelledby="logoTitle logoDesc" xmlns= "http://www.w3.org/2000/svg" x= "0px" y= "0px"
				width= "730px" height= "310px" viewBox= "0 0 730 310" enableBackground= "new 0 0 730 310" >
				    <title id = "logoTitle">Siso Logo</title>
				    <desc id = "logoDesc">UX, Mobile and Web</desc>
				    <g>
					  <path fill= "#EF4939" d= "M106.676,196.696c11.308-10.203,18.454-25.08,18.454-41.469c0.553-12.686-3.406-24.469-10.396-33.971
					c-1.174-1.598-2.439-3.121-3.776-4.582l0.06-0.051c-9.332-10.201-22.514-17.01-37.334-18.029c-0.227-0.025-0.449-0.037-0.673-0.059
					l-0.006,0.086c-1.071-0.064-2.149-0.104-3.234-0.104c-0.91,0-1.813,0.025-2.711,0.066l0.004-0.051
					c-15.499-0.67-26.921-12.582-25.61-28.32c0-14.855,12.146-27.004,28.342-27.004c14.845,0,26.991,13.498,26.991,28.354
					c0,9.832-4.479,18.164-11.613,22.9c9.656,2.469,18.566,7.232,26.023,13.979c8.653-9.846,13.934-22.803,13.934-36.879
					c1.35-31.055-24.292-56.707-55.335-56.707c-31.041,0-56.683,24.301-56.683,55.357c-0.742,17.068,6.681,32.494,18.661,42.936
					c-10.985,10.041-18.005,24.455-18.712,40.729c0,12.396,3.881,23.926,10.508,33.312c8.689,12.303,22.108,20.906,37.753,22.926
					c0.328,0.043,0.653,0.092,0.982,0.127c0.181,0.023,0.36,0.045,0.542,0.064c0.512,0.059,1.022,0.129,1.54,0.176
					c0.224,0.025,0.446,0.043,0.67,0.068l0.006-0.074c1.111,0.068,2.229,0.111,3.359,0.111c0.866,0.037,1.728,0.047,2.586,0.043
					c0.262,0,0.523-0.008,0.785-0.014c15.179,1.07,26.277,14.053,24.982,28.279c0,16.201-12.15,28.355-28.353,28.355
					c-14.853-1.352-27.006-13.5-27.006-29.705c0-9.471,5.494-17.838,13.325-22.664c-10.106-2.449-19.394-7.412-27.094-14.482
					c-9.042,9.752-14.584,22.719-14.584,37.146c0,31.055,24.304,56.709,55.359,56.709c31.055,1.352,56.71-24.303,56.71-55.359
					C125.867,221.933,118.535,206.993,106.676,196.696z M68.421,182.237c-0.715,0-1.421-0.037-2.124-0.094
					c-4.275-0.463-8.18-1.746-11.542-3.703c-3.813-2.305-7.033-5.559-9.351-9.512c-2.527-4.305-3.989-9.434-3.989-15.051
					c0-13.264,10.778-24.371,23.665-26.592c1.54-0.266,3.106-0.412,4.691-0.412c10.15,0,18.709,5.301,23.689,12.912
					c2.969,4.537,4.666,9.895,4.666,15.441c-1.206,14.449-10.998,25.666-24.589,26.975C71.884,182.36,70.178,182.382,68.421,182.237z"
					/>
					<g>
						<path d= "M166.43,274.863c-12.61-12.867-18.91-29.693-18.91-50.49v-10.527c0-2.594,1.297-3.898,3.899-3.898h28.852
						c2.596,0,3.898,1.305,3.898,3.898v8.576c0,11.961,2.986,21.512,8.968,28.658c5.977,7.152,13.646,10.723,23.004,10.723
						s17.087-3.441,23.198-10.332c6.104-6.885,9.163-15.918,9.163-27.098c0-7.537-1.627-14.164-4.874-19.885
						c-3.254-5.715-7.542-10.85-12.867-15.4c-5.331-4.545-13.975-11.24-25.927-20.08c-13.257-9.875-23.655-18.324-31.191-25.342
						c-7.542-7.018-13.908-15.463-19.104-25.344c-5.202-9.875-7.798-21.443-7.798-34.699c0-21.055,6.238-37.752,18.715-50.102
						c12.476-12.342,28.718-18.52,48.736-18.52c20.792,0,37.491,6.629,50.101,19.885c12.604,13.256,18.909,30.674,18.909,52.244v9.748
						c0,2.602-1.303,3.898-3.898,3.898h-28.852c-2.602,0-3.899-1.297-3.899-3.898V86.352c0-11.695-2.992-21.115-8.968-28.266
						c-5.981-7.146-13.779-10.723-23.393-10.723c-9.101,0-16.443,3.186-22.029,9.553c-5.592,6.371-8.383,15.271-8.383,26.707
						c0,10.398,2.858,19.17,8.578,26.318c5.715,7.15,16.631,16.703,32.75,28.656c15.852,11.697,27.743,21.188,35.675,28.461
						c7.926,7.281,14.037,15.273,18.325,23.979c4.289,8.713,6.434,19.045,6.434,30.996c0,21.834-6.434,39.318-19.3,52.441
						c-12.866,13.127-29.571,19.688-50.101,19.688C195.604,294.162,179.034,287.73,166.43,274.863z"/>
						<path d= "M323.355,287.145V22.02c0-2.594,1.298-3.898,3.899-3.898h29.631c2.596,0,3.899,1.305,3.899,3.898v265.125
						c0,2.602-1.303,3.9-3.899,3.9h-29.631C324.653,291.045,323.355,289.746,323.355,287.145z"/>
						<path d= "M421.407,274.863c-12.61-12.867-18.909-29.693-18.909-50.49v-10.527c0-2.594,1.297-3.898,3.898-3.898h28.852
						c2.596,0,3.899,1.305,3.899,3.898v8.576c0,11.961,2.985,21.512,8.968,28.658c5.976,7.152,13.646,10.723,23.003,10.723
						s17.088-3.441,23.199-10.332c6.104-6.885,9.162-15.918,9.162-27.098c0-7.537-1.626-14.164-4.874-19.885
						c-3.253-5.715-7.542-10.85-12.866-15.4c-5.331-4.545-13.976-11.24-25.928-20.08c-13.256-9.875-23.655-18.324-31.191-25.342
						c-7.541-7.018-13.908-15.463-19.104-25.344c-5.202-9.875-7.798-21.443-7.798-34.699c0-21.055,6.239-37.752,18.715-50.102
						c12.477-12.342,28.719-18.52,48.736-18.52c20.792,0,37.49,6.629,50.102,19.885c12.604,13.256,18.909,30.674,18.909,52.244v9.748
						c0,2.602-1.304,3.898-3.899,3.898h-28.852c-2.602,0-3.899-1.297-3.899-3.898V86.352c0-11.695-2.991-21.115-8.967-28.266
						c-5.982-7.146-13.78-10.723-23.394-10.723c-9.102,0-16.442,3.186-22.028,9.553c-5.593,6.371-8.383,15.271-8.383,26.707
						c0,10.398,2.857,19.17,8.578,26.318c5.714,7.15,16.63,16.703,32.75,28.656c15.851,11.697,27.743,21.188,35.674,28.461
						c7.926,7.281,14.037,15.273,18.326,23.979c4.288,8.713,6.433,19.045,6.433,30.996c0,21.834-6.433,39.318-19.3,52.441
						c-12.866,13.127-29.57,19.688-50.1,19.688C450.582,294.162,434.013,287.73,421.407,274.863z"/>
						<path d= "M592.37,274.668c-13-12.994-19.494-30.277-19.494-51.855V86.742c0-21.572,6.494-38.922,19.494-52.051
						c12.995-13.121,30.15-19.689,51.465-19.689c21.573,0,38.923,6.568,52.05,19.689c13.122,13.129,19.69,30.479,19.69,52.051v136.07
						c0,21.578-6.568,38.861-19.69,51.855c-13.127,13-30.478,19.494-52.05,19.494C622.521,294.162,605.365,287.668,592.37,274.668z
						M668.789,251.471c6.239-6.885,9.358-15.918,9.358-27.098V84.791c0-11.17-3.119-20.205-9.358-27.096
						c-6.238-6.885-14.559-10.332-24.953-10.332c-10.137,0-18.264,3.447-24.368,10.332c-6.11,6.891-9.163,15.926-9.163,27.096v139.582
						c0,11.18,3.053,20.213,9.163,27.098c6.104,6.891,14.23,10.332,24.368,10.332C654.229,261.803,662.551,258.361,668.789,251.471z"/>
					</g>
				</g>
			</svg>
		</div>
		<DateComponent />
    <PageIntro pageTitle="Home" output="intro"/>
        </div>
        <div id="homePanels" className="pagePanels">
          <HomePanels />
        </div>
        <div id="homeWhy" className="greyBkgd">
          <WhySiso />
        </div>
		<div id="homePort" claddName="whiteBkgd">
			<h1 id = "portTitle" >PORTFOLIO</h1>
			<p className="panelText">Interested in what we do? Then check out the portfolio of our founder - Dominic Rogers, who leads all of UX and BA projects</p>
			<a
  href="https://uxfol.io/dominicrogers"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    backgroundColor: "#ef4939",
    color: "#ffffff",
    padding: "12px 20px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    display: "inline-block",
  }}
>
  OPEN PORTFOLIO
</a>

		</div>
      </div>

    );
  }
export default Home;
